import(/* webpackMode: "eager" */ "/vercel/path0/src/app/right-now/page.tsx");
